var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7902 4.32H1.11429C0.498883 4.32 0 3.83647 0 3.24C0 2.64353 0.498883 2.16 1.11429 2.16H15.7902C16.2491 0.901592 17.4874 0 18.9429 0C20.3984 0 21.6366 0.901592 22.0955 2.16H24.8857C25.5011 2.16 26 2.64353 26 3.24C26 3.83647 25.5011 4.32 24.8857 4.32H22.0955C21.6366 5.57841 20.3984 6.48 18.9429 6.48C17.4874 6.48 16.2491 5.57841 15.7902 4.32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8857 15.84C25.5011 15.84 26 15.3565 26 14.76C26 14.1635 25.5011 13.68 24.8857 13.68H10.2098C9.75088 12.4216 8.51264 11.52 7.05714 11.52C5.60164 11.52 4.3634 12.4216 3.9045 13.68H1.11429C0.498883 13.68 0 14.1635 0 14.76C0 15.3565 0.498883 15.84 1.11429 15.84H3.9045C4.3634 17.0984 5.60164 18 7.05714 18C8.51264 18 9.75088 17.0984 10.2098 15.84H24.8857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.8bfdd0172963964283a01c3c7d2b8b67.svg";
export { ForwardRef as ReactComponent };